import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCywlQI2AxIWUITQLtdOtM0dsv3KoHHNJQ",
  authDomain: "quiz-composer.firebaseapp.com",
  projectId: "quiz-composer",
  storageBucket: "quiz-composer.appspot.com",
  messagingSenderId: "864265241216",
  appId: "1:864265241216:web:4f8b7c167a378466481c65",
  measurementId: "G-9L313HFEEP"
};
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
const storageService = getStorage(firebaseApp);

export default class Storage {
	// Create the file metadata
	/** @type {any} */
	metadata = {
	  contentType: 'image/jpeg,image/png,image/jpg'
	};

	static uploadFile(file, callback, metadata=Storage.metadata) {
		const storageRef = ref(storageService, `images/${file.name}`);
		const uploadTask = uploadBytesResumable(storageRef, file, metadata);

		// Listen for state changes, errors, and completion of the upload.
		uploadTask.on('state_changed',
		  (snapshot) => {
		    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
		    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
		    console.log('Upload is ' + progress + '% done');
		    switch (snapshot.state) {
		      case 'paused':
		        console.log('Upload is paused');
		        break;
		      case 'running':
		        console.log('Upload is running');
		        break;
		    }
		  }, 
		  (error) => {
		    // A full list of error codes is available at
		    // https://firebase.google.com/docs/storage/web/handle-errors
		    switch (error.code) {
		      case 'storage/unauthorized':
		        console.error("User doesn't have permission to access the object", error.toString());
		        break;
		      case 'storage/canceled':
		        console.error("User canceled the upload", error.toString());
		        break;
		      case 'storage/unknown':
		        console.error("Unknown error occurred, inspect error.serverResponse", error.toString());
		        const message = 'serverResponse' in error ?
		        								 error.serverResponse :
		        								 error;
		        console.error(message, error.toString());
		        break;
	        default:
						console.error("Unknown error occurred", error.toString());
		    }
		  }, 
		  () => {
		    // Upload completed successfully, now we can get the download URL
		    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
		      console.log('File available at', downloadURL);
		      callback(downloadURL);
		    });
		  }
		);
	}
}
